import React, {useState, useEffect, useRef } from 'react';

import { useRouter } from 'next/router';

import { ajaxor4 } from '../../common/basic';


import defaultStates from '../../../src-component/defaultStates';
// import { Link, browserHistory } from 'react-router';
// import Router from 'next/router'

if (process.browser) {
  var KaKao = require('../../../public/dist/kakao');
  // console.log("Kakao: ", Kakao);
  // console.log("JSON Kakao: ", JSON.stringify(Kakao));
  Kakao.init('8c196f82159b462d6611bb365f5ed049');
  // http://localhost:3000/oauth
}


export default props=>{
  if(!process.browser) return <></>;

  //
  const [id, setID] = useState(process.browser && location.href.indexOf('localhost')>0 ? 'lcg2004@naver.com' : '');
  const [password, setPassword] = useState(process.browser && location.href.indexOf('localhost') > 0 ? '11111111' : '');

  const [m1, setM1] = useState('');
  const [m2, setM2] = useState('');

  const rID = useRef(null);
  const rPassword = useRef(null);

  function examID(){
    let sentence = rID.current.value;
    setID(sentence);

    if (sentence.length == 0) setM1(''); else 
    if( 1==0
      || sentence.split('@').length !== 2
      || sentence.indexOf('.') < 1
      || sentence.length > 255
      || sentence.indexOf(' ') > -1
    ) setM1('올바르지 않은 이메일 형식입니다.');
    else setM1('');
  }

  function examPassword(){
    let sentence = rPassword.current.value;
    setPassword(sentence);

    if (sentence.length == 0) setM2(''); else 
    if (sentence.length < 8) setM2('비밀번호는 8자리 이상이어야 합니다.');
    else if (sentence.search(/[0-9]/) < 0) setM2('비밀번호는 숫자가 최소 1개씩 포함되어야 합니다.');
    else if (sentence.length > 25) setM2('비밀번호는 최대 25자까지 입력이 가능합니다.');
    else setM2('');
  }

  function onClickLoginButton() {
    if (!rID.current.value.match(/^\S+\@\w+(\.\w+)+$/)) {
      alert('잘못된 이메일형식입니다.');
    } else {
      const formData = new FormData();
      formData.append('email', rID.current.value);
      formData.append('password', rPassword.current.value);

      $.ajax({
        type: 'POST',
        url: `${defaultStates.host}/auth/login/email`,
        data: formData,
        contentType: false,
        dataType: 'json',
        processData: false,
        headers: {
          'Client-Type': 'webapp',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': document.location.host,
          "Authorization": "Bearer " + localStorage[defaultStates.localStorageKey],
        },
        success: (res) => {
          // console.log("res: ", res);
          // {"meta":{"code":200},"data":{"user":{"id":254044,"user_group_id":0,"email":"lcg2004@naver.com","username":"lcaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaag","nickname":"CAMSCON Inspirer","intro":"자기소개1","gender":1,"birthday":"1234-12-01","instagram":"aer@@daf.com","website":"http://naver.com","slug":null,"api_token":"C6oVw7c2ZmXdO1QveQjwr9.....","preferences":null,"created_at":"2019-09-27 11:09:04","updated_at":"2020-01-04 16:11:31","profile_picture":[],"is_inspirer":false,"is_admin":false}}}
          if (res.meta && +res.meta.code === 200) {
            localStorage[defaultStates.localStorageKey] = res.data.user.api_token;
            if (!res.data.user.username) {
              // console.log("로그인성공(사용자명 없음)");
              // browserHistory.push('/set-username');// 기존: 사용자명 입력으로 이동.
              Router.push('/set-username');
            } else {
              // browserHistory.push('/');
              location.href='/';
            }
          } else if (res.meta && +res.meta.code === 422) {
            if (res.data.email) {
              alert(res.data.email[0]);
            }
          } else if (res.meta && +res.meta.code === 400 || +res.meta.code === 440) {
            alert('비밀번호가 틀렸습니다.');
          } else {
            alert('로그인에 실패했습니다.\n다시 시도해주세요.');
          }
        },
        error: (x, s, e) => {
          // lcg
          // console.log(x, s, e);
          alert('로그인에 실패했습니다.');
        }
      });
    }
  }




  //페이스북로그인***********************
  function checkLoginState() {
    
      if(1==1) return;
    FB.getLoginStatus(function (response) {
      console.log("checkLoginState() > FB.getLoginStatus()");
      statusChangeCallback(response);
    });
  }

  // (function (d, s, id) {
  //   console.log("ELEMENTALS 1. (function(d, s, id) {....");
  //   var js, fjs = d.getElementsByTagName(s)[0];
  //   if (d.getElementById(id)) return;
  //   js = d.createElement(s); js.id = id;
  //   js.src = "//connect.facebook.net/ko_KR/sdk.js";
  //   fjs.parentNode.insertBefore(js, fjs);
  // }( document, 'script', 'facebook-jssdk'));

  // window.fbAsyncInit = function () {
  //   console.log("ELEMENTALS 2. window.fbAsyncInit");
  //   FB.init({
  //     appId: "562009567255774",
  //     cookie: true,	// enable cookies to allow the server to access
  //     xfbml: true,	// parse social plugins on this page
  //     // version: 'v2.8' // use graph api version 2.8
  //     version: 'v3.1' // 3.1
  //   });

  //   FB.getLoginStatus(function (response) {
  //     console.log("ELEMENTALS 3. FB.getLoginStatus()");

  //     statusChangeCallback(response);
  //   });
  // };


  function statusChangeCallback(response) {
    console.log('ELEMENTALS 4. statusChangeCallback');
    //console.log(response);
    if (response.status === 'connected') {
      console.log("connected");
      //goFacebook();//자동으로 로그인 해버린다.
    } else if (response.status === 'not_authorized') {
      console.log("not_authorized: " + "Please log into this app.");
    } else {
      console.log("unknown: " + "Please log into Facebook");
    }
  }



  function goFacebook() {
    console.log("1. goFacebook()");
    console.log('Welcome!	Fetching your information....');
    FB.login(function (response) {
      if (response.status === 'connected') {
        // Logged into your app and Facebook.
        console.log("connected: ");
        takeOver();
      } else if (response.status === 'not_authorized') {
        console.log('not_authorized');
        // The person is logged into Facebook, but not your app.
      } else {
        console.log('else response: ' + response.status);
        // The person is not logged into Facebook, so we're not sure if
        // they are logged into this app or not.
      }
    });
  }

  function takeOver() {
    FB.api('/me', { fields: 'id, email, name, picture.width(100).height(100)' }, function (response) {
      console.log(response);

      if(1==1) return;
      document.getElementById("specific_id").value = response.id;
      document.getElementById("oauth_provider").value = "facebook";

      document.getElementById("mail_address").value = response.email;
      document.getElementById("nickname").value = response.name;
      document.getElementById("psa_url").value = response.picture.data.url;
      //		document.getElementById("psa_url").value = "http://graph.facebook.com/v2.8/"+response.id+"/picture?height=100&width=100";

      document.getElementById("loginForm").submit();
    });
  }

  //카카오로그인***********************
  function goKakao() {
    console.log("로그인 창을 띄웁니다.: ");
    
    Kakao.Auth.login({
      success: function (authObj) {
        // 로그인 성공시, API를 호출합니다.
        console.log("Kakao.Auth.login. 로그인 성공시, API를 호출합니다.:", JSON.stringify(authObj));
        Kakao.API.request({
          url: '/v2/user/me',
          success: function (res) {
            console.log('request.success: : ', JSON.stringify(res));
            onKaKaoSuccess(authObj.access_token, res.id);
          },
          fail: function (error) {
            console.log('request.fail: ', JSON.stringify(error));
          }
        });
      },
      fail: function (err) {
        console.log('Kakao.Auth.login.fail: ', JSON.stringify(err));
      }
    });
  };

  function onKaKaoSuccess(kakao_access_token, kakao_user_id){// id, nickname, access_token, psa_url) {
    console.log("onKaKaoSucSuccess: ", kakao_access_token, kakao_user_id);

    console.log("ajaxor4: ");
    ajaxor4({
      url:"/auth/login/kakao",
      data:{
        kakao_access_token: kakao_access_token,
        kakao_user_id: kakao_user_id,
      },
      callback:authLoginKaKao,
    });
  }

  function authLoginKaKao(rd){
    console.log("authLoginKaKao: ");

    if(typeof rd=='undefined'){
      // alert('카카오로그인 회원이 아닙니다.');
      return;
    }
    
    console.log("rd: ",rd);

    localStorage[defaultStates.localStorageKey] = rd.user.api_token;
    if (!rd.user.username) {
      // username 이 없으면, 과거 회원가입페이지 같은데로 갔다.
      // browserHistory.push('/set-username');
    }
    // browserHistory.push('/');

    if(process.browser) location.href="/";
  }


  function fillLoginer() {
    ajaxor2({
      url: "/user/get",
      callback: callback,
    });

    function callback(r) {
      if (r == undefined) return localStorage.removeItem('loginer');

      if (r.user.profile_picture.length > 0) {
        r.user.profile_picture[0].archived_url =
          r.user.profile_picture[0].archived_url.split("http://localhost:8000").join("https://api.camscon.kr");
      }

      setMyInfo(r.user); // 이변수

      localStorage['loginer'] = JSON.stringify(r.user); // 브라우저 로컬스토리지
    }

  }

  useEffect(()=>{

    setID('');
    setPassword('');

    if(process.browser && location.href.indexOf('localhost') > 0){
      setID('lcg2004@naver.com');
      setPassword('11111111');      
    }

    setM1('');
    setM2('');


    return ()=>{;};
  }, [props.display]);

  function doFacebookProcedure(){
    (function (d, s, id) {
      console.log("ELEMENTALS 1. (function(d, s, id) {....");
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/ko_KR/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    window.fbAsyncInit = function () {
      console.log("ELEMENTALS 2. window.fbAsyncInit");
      FB.init({
        appId: "562009567255774",
        cookie: true,	// enable cookies to allow the server to access
        xfbml: true,	// parse social plugins on this page
        // version: 'v2.8' // use graph api version 2.8
        // version: 'v3.1' // 3.1
        version: 'v7.0' // 7.0
      });

      FB.getLoginStatus(function (response) {
        console.log("ELEMENTALS 3. FB.getLoginStatus()");

        statusChangeCallback(response);
      });
    };

  }

// 210512 vertically-middle를 왜없앴는지 모름.
// const jsx = (<div className="Login Join this-content popup fullom "
// 210512 vertically-middle, 로그인모바일이 깨지므로 일단 다시 넣었다.
  const jsx = (<div className="Login Join this-content popup fullom vertically-middle" 
  style={{ display: props.display }} 
  onClick={e => e.stopPropagation()}
  onMouseDown={e => e.stopPropagation()}
  onMouseUp={e => e.stopPropagation()}
  >
    <style jsx>{`

.Login.this-content{
    width: 460px;
    padding: 45px 60px;

    margin: auto;
    background-color: white;

    overflow-y: auto;
    position: fixed;
    top: 50px;
    bottom: 0;
    margin: 0 auto;
    left: 0;
    right: 0;

    max-height: 682px;
    box-sizing: border-box;

}

.Join.this-content{

    width: 460px;
    padding: 45px 60px;

    margin: auto;
    background-color: white;

    overflow-y: auto;
    position: fixed;
    top: 50px;
    bottom: 0;
    margin: 0 auto;
    left: 0;
    right: 0;

    max-height: 682px;
    box-sizing: border-box;

    text-align: left;

}

/* 상하중앙정렬 */
.this-content.vertically-middle{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    border: 0;
    height: 670px;
    text-align: left;
}

.x{
    float:right;
    /* margin: -20px -20px 0 0; */
    margin: -30px -40px 0 0;
}

.logo{
    text-align:center;
}

.title{
    font-size: 16px;
    text-align: center;
    color: #343a40;
}


.button42{
    width: 100%;
    height: 42px;
    text-align: center;
    /* padding-top: 12px; */
    margin: 10px 0;
    vertical-align:middle;
    padding: 0;
    line-height: 42px;

}

.button42 img{
  vertical-align:middle;
}

.button0{
    width: 100%;
    height: 42px;
    text-align: center;
    padding-top: 12px;
    margin: 8px 0;
    vertical-align:middle;
}

.button0 img{
  vertical-align:middle;
}

.button1{
    background-color: #325a9f;
    font-size: 14px;
    color: white;
}

.button2{
    background-color: #feea0e;
    font-size: 14px;
    color: #343a40;
}

.or{
  text-align: center;
}

.label1{
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.25px;
  color: #868e96;
  margin: 15px 0 15px;
}

.input1{
    width: 100%;
    /* height: 24px; */
    font-size: 14px;
    color: #adb5bd;
    border: none;
    padding-top: 5px;
}


.input1::placeholder{
    font-size: 12px;
    text-align: left;
}


.horizon-bar3 {
    width: 100%;
    height: 1px;
    background-color: #ced4da;
    margin: 8px 0;
}

.comment1{
  font-size: 12px;
  color: #55d5ce;
  /* margin-bottom: 20px; */
}
.sentence1{
  font-size: 14px;
  color: #343a40;
  text-align:right;
}
.button3{
    background-color: #212529;
    color: white;
    font-size: 14px;
    margin:24px 0 32px;
}

.sentence2{
  font-size: 14px;
  color: #343a40;
  text-align:center;
}

.whiteback {
  background-color:white;
  margin-top: 12px;
}

.horizon-bar-half{
    width: 45%;
    height: 1px;
    background-color: #e9ecef;
    margin: 5px 0 0 0;
}

.horizon-bar-half.left{
  float:left;
}

.horizon-bar-half.right{
  float:right;
}

@media all and (max-width:606px) {
  /* 상하중앙정렬 */
  .this-content.vertically-middle{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: none;
    height: auto;
    width: auto;
  }

  .x{
        margin: 0;
  }

  .logo{
    padding: 40px 0 0 0;
  }
}


`}</style>

    <div className="x">
      <a onClick={props.hide}><img src="/assets/images2/x_dark.svg" /></a>
    </div>
    <div className="logo"><img src="/assets/images/logo-camscon.svg" /></div>
    <div className="">&nbsp;</div>
    <div className="">&nbsp;</div>

    {/* 그리고, "당신의 패션사진, 데일리룩을 공유하세요."가 디바이스별로 다 깨지는데 이 텍스트 삭제해주셔도 될것같아요~ */}
    {/* <div className="title">당신의 패션사진, 데일리룩을 공유하세요.</div> */}
    <div className="title">&nbsp;</div>
    <div className="">&nbsp;</div>
    {/* <a onClick={goFacebook}>
      <div className="button42 button1">&nbsp;
        <img src="/assets/images/path-3.svg" />&nbsp;&nbsp;&nbsp;페이스북으로 계속하기
      </div>
    </a> */}

    <a onClick={goKakao}>
      <div className="button42 button2">
        <img src="/assets/images/ico-kakao.svg" />&nbsp;&nbsp;&nbsp;카카오로 계속하기
      </div>
    </a>
    
    <div className="whiteback or">
      <div className="horizon-bar-half left" /> or <div className="horizon-bar-half right" />
    </div>
    
    <div className="label1">이메일(아이디)</div>
<form autoComplete="off" >
    <input className="input1" placeholder="가입하신 이메일 입력, 예)example@gmail.com" 
      ref={rID} value={id} 
      onChange={e => setID(e.target.value)} 
        onBlur={examID} 
    />

    <div className="horizon-bar3" />
    <div className="comment1">{m1}&nbsp;</div>
    <div className="label1">비밀번호</div>
    <input className="input1" type="password" autoComplete="off" placeholder="" 
      ref={rPassword} value={password} onChange={(e)=>examPassword()} 
      onKeyDown={e => {
        if (e.keyCode == 13) onClickLoginButton();
      }}
    />
</form>
    <div className="horizon-bar3" />
    <div className=""></div>
    <div className="comment1">{m2}&nbsp;</div>
    <div className="">&nbsp;</div>
    
    {/* 1. 리액트 컴포넌트로 보이는 방법 */}
    {/* <a onClick={ props.setResetPassword }> */}
    
    
    {/* 2. 운영 구url을 새창에서 열기 */}
    {/* <a target="_blank" href="https://api.camscon.kr/reset-password"> */}
    
    {/* 3. 로컬 구url을 새창에서 열기 */}
    {/* <a target="_blank" href="http://localhost:8000/reset-password"> */}

    {/* 4. 리액트 컴포넌트로 보이되 iframe으로 여는 방법 X-> 다시한번 로그인해보시겠어요? 이거때문에 안된다. */}
    <a onClick={ props.setResetPassword }>

      <div className="sentence1">비밀번호를 잊으셨나요?</div>
    </a>

    <a onClick={onClickLoginButton}>
      <div className="button42 button3">로그인</div>
    </a>

    <a onClick={props.setJoin}>
      <div className="sentence2">아직 캠스콘 회원이 아니신가요?</div>
    </a>



  </div>);  return (jsx);

}
